export const siteContent = {
  global: {
    siteName: 'Rocket Van Express',
    tagline: 'Fast • Reliable',
    headline: 'Fast & Reliable Mini Moves and Deliveries',
    subHeadline: 'Stellenbosch & Cape Town | Fast • Reliable',
    phone: '+27 736596239',
    whatsapp: '+27736596239',
    email: 'Info@rocketvan.co.za',
    operatingHours: 'Mon-Fri: 7:00 AM - 7:00 PM | Sat: 8:00 AM - 4:00 PM | Sun: Closed',
    
    primaryCTA: 'WhatsApp for Quote',
    secondaryCTA: 'Get a Quote',
    
    trustProof: 'Quote in minutes • Real updates • Proof-of-delivery',
    
    metaDefaults: {
      title: 'Rocket Van Express - Fast & Reliable Mini Moves and Deliveries | Stellenbosch & Cape Town',
      description: 'Local mini moves and deliveries across Stellenbosch and Cape Town. Same-day options, WhatsApp updates, and proof-of-delivery. Quote in minutes!',
      ogImage: '/og-image.jpg'
    }
  },

  home: {
    meta: {
      title: 'Rocket Van Express - Mini Moves & Deliveries | Stellenbosch & Cape Town',
      description: 'Fast, reliable mini moves and deliveries in Stellenbosch & Cape Town. Same-day service, WhatsApp updates, proof-of-delivery. Get your quote in minutes!',
    },
    
    hero: {
      h1: 'Fast & Reliable Mini Moves and Deliveries',
      subHeadline: 'Stellenbosch & Cape Town | Fast • Reliable',
      supportLine: 'Quote in minutes • Real updates • Proof-of-delivery'
    },

    whyRocketVan: {
      headline: 'Built for speed. Trusted for care.',
      bullets: [
        'Care-first handling with straps and blankets',
        'Clear pricing rules with no surprises',
        'WhatsApp-first updates and support',
        'Proof-of-delivery on completion'
      ]
    },

    areasServed: {
      headline: 'Stellenbosch & Greater Cape Town',
      list: 'Stellenbosch • Somerset West • Paarl • Strand • Bellville • Cape Town CBD • Northern & Southern Suburbs'
    }
  },

  deliveries: {
    meta: {
      title: 'Local Delivery Services | Rocket Van Express Stellenbosch & Cape Town',
      description: 'Fast local deliveries across Stellenbosch & Cape Town. Store pickups, documents, marketplace items. Same-day options with WhatsApp updates.',
    },
    
    hero: {
      h1: 'Local Deliveries',
      subHeadline: 'Fast, reliable delivery service across Stellenbosch & Cape Town'
    }
  },

  miniMoves: {
    meta: {
      title: 'Mini-Moves & Small Removals | Rocket Van Express Western Cape',
      description: 'Professional mini-moves and small removals in Stellenbosch & Cape Town. Furniture, appliances, boxes. Care-first handling with helpers available.',
    },
    
    hero: {
      h1: 'Mini-Moves & Small Removals',
      subHeadline: 'From a single couch to a full bachelor apartment - we handle it with care'
    }
  },

  business: {
    meta: {
      title: 'Rocket Van Express Business - Monthly Billing & Priority Delivery',
      description: 'Business delivery accounts with monthly billing, priority dispatch, and consolidated invoicing. Perfect for e-commerce and regular deliveries.',
    },
    
    hero: {
      h1: 'Rocket Van Express Business',
      subHeadline: 'Monthly billing, priority support, and volume-based pricing for businesses'
    },
    
    whoItsFor: [
      { title: 'E-commerce Stores', description: 'Daily order fulfillment and customer deliveries' },
      { title: 'Social Sellers', description: 'Facebook, Instagram, WhatsApp business deliveries' },
      { title: 'Professional Services', description: 'Document delivery, equipment transport' },
      { title: 'Hospitality', description: 'Supply runs, event equipment moves' },
      { title: 'Property Management', description: 'Keys, documents, small furniture moves' },
      { title: 'Retailers', description: 'Store transfers, customer home deliveries' }
    ],
    
    benefits: [
      'Monthly consolidated invoicing',
      'Priority dispatch queue',
      'Dedicated account contact',
      'Proof-of-delivery for every order',
      '7-30 day payment terms',
      'Service-level expectations',
      'Volume-based pricing',
      'Real-time tracking via WhatsApp'
    ],
    
    howItWorks: [
      { step: 1, title: 'Apply', text: 'Fill in the form or WhatsApp us' },
      { step: 2, title: 'Setup', text: 'Account manager contacts you within 24h' },
      { step: 3, title: 'Start Using', text: 'Begin booking with priority dispatch' },
      { step: 4, title: 'Get Invoiced', text: 'Consolidated monthly invoice' }
    ],
    
    sections: {
      whoItsForTitle: 'Who It\'s For',
      packagesTitle: 'Business Packages',
      benefitsTitle: 'Why Choose Rocket Van Express Business?',
      howItWorksTitle: 'How It Works',
      applyTitle: 'Apply for a Business Account',
      applySubtitle: 'We\'ll set up your account and get you started within 24 hours'
    },
    
    cta: {
      whatsapp: 'WhatsApp Us',
      apply: 'Apply Now',
      submit: 'Submit Application',
      whatsappAlt: 'WhatsApp Instead'
    }
  },

  forms: {
    delivery: {
      pickupLabel: 'Pickup Address/Suburb',
      pickupPlaceholder: 'e.g., Stellenbosch CBD',
      dropoffLabel: 'Drop-off Address/Suburb',
      dropoffPlaceholder: 'e.g., Somerset West',
      itemLabel: 'Item Description',
      itemPlaceholder: 'e.g., 3 boxes, small table',
      datetimeLabel: 'Preferred Date/Time',
      nameLabel: 'Your Name',
      namePlaceholder: 'Full name',
      mobileLabel: 'Mobile Number',
      mobilePlaceholder: '+27',
      notesLabel: 'Access Notes',
      notesPlaceholder: 'Stairs, lift access, parking, etc.',
      submitButton: 'Submit Quote Request',
      whatsappButton: 'Continue on WhatsApp'
    },

    miniMove: {
      helpersLabel: 'Helpers Needed',
      helpersOptions: ['Driver only', 'Driver + 1 helper', 'Driver + 2 helpers'],
      floorsLabel: 'Floors/Lift Access',
      floorsPlaceholder: 'e.g., 2nd floor, no lift',
      itemsLabel: 'Item List',
      itemsPlaceholder: 'List furniture, appliances, boxes...',
      photosButton: 'Send Photos on WhatsApp'
    },

    business: {
      businessNameLabel: 'Business Name',
      contactPersonLabel: 'Contact Person',
      emailLabel: 'Email Address',
      volumeLabel: 'Estimated Monthly Volume',
      volumeOptions: ['1-10 deliveries/month', '11-30 deliveries/month', '31+ deliveries/month'],
      areaLabel: 'Primary Service Area',
      businessTypeLabel: 'Type of Business',
      businessTypePlaceholder: 'e.g., E-commerce, Restaurant, Property'
    },

    validation: {
      required: 'This field is required',
      email: 'Please enter a valid email address',
      phone: 'Please enter a valid phone number',
      minLength: 'Please provide more details'
    },

    success: {
      delivery: 'Delivery quote submitted! Reference: {quoteId}',
      miniMove: 'Mini-move quote submitted! Reference: {quoteId}',
      business: 'Business application submitted! Reference: {applicationId}',
      contact: 'Message sent! We\'ll respond within 24 hours. Reference: {submissionId}'
    }
  },

  errors: {
    404: {
      title: '404 - Page Not Found',
      message: 'The page you\'re looking for doesn\'t exist.',
      cta: 'Back to Home',
      whatsappCTA: 'Need help? WhatsApp us'
    },
    
    500: {
      title: 'Something went wrong',
      message: 'We\'re working on fixing this. Please try again or contact us.',
      cta: 'Try Again',
      whatsappCTA: 'Contact Support'
    },
    
    formError: {
      generic: 'Failed to submit. Please try WhatsApp instead.',
      network: 'Connection error. Please check your internet and try again.',
      timeout: 'Request timed out. Please try again.'
    }
  },

  whatsappTemplates: {
    generic: 'Hi Rocket Van Express, I need a quote.\nPickup: __\nDrop-off: __\nItems: __\nDate/time: __',
    
    delivery: 'Hi Rocket Van Express, I need a DELIVERY quote.\nRef: {refId}\nPickup: {pickup}\nDrop-off: {dropoff}\nItem: {item}\nDate/time: {datetime}',
    
    miniMove: 'Hi Rocket Van Express, I need a MINI-MOVE quote.\nRef: {refId}\nPickup: {pickup}\nDrop-off: {dropoff}\nItems: {items}\nHelpers: {helpers}\nDate/time: {datetime}\nPhotos: (sending)',
    
    business: 'Hi Rocket Van Express, I\'d like a BUSINESS account.\nRef: {refId}\nCompany: {businessName}\nMonthly deliveries: {volume}\nAreas: {area}\nEmail: {email}',
    
    track: 'Hi Rocket Van Express, I need to track my booking.\nReference: {bookingRef}',
    
    reschedule: 'Hi Rocket Van Express, I need to reschedule.\nRef: {refId}\nNew date/time: {newDatetime}',
    
    cancel: 'Hi Rocket Van Express, I need to cancel my booking.\nRef: {refId}\nReason: {reason}',
    
    damageClaim: 'Hi Rocket Van Express Support, I need to log a damage claim.\nRef: {refId}\nDescription: {description}\nPhotos: (sending)',
    
    support: 'Hi Rocket Van Express Support, I need help with: {issue}\nRef: {refId}'
  }
};

export default siteContent;
